import { Link } from "react-router-dom";
import { CheckIcon, plans } from "./constants";
import { useState } from "react";

const Hero = () => {
  const [billingCycle, setBillingCycle] = useState("yearly");

  return (
    <section className="py-10 md:py-[54px] relative overflow-hidden bg-white bg-pricing-hero">
      <div className="container px-3">
        <div className="text-center mb-10 space-y-4">
          <h2 className="text-[24px] lg:text-[36px] font-bold text-black">
            Flexible Pricing for Diverse Needs
          </h2>
          <p className="text-[#222] md:text-xl max-w-[802px] mx-auto">
            Choose a plan that aligns with your project’s scope—whether you're
            experimenting or deploying at scale.
          </p>

          {/* Billing Toggle */}
          <div className="flex items-center justify-center bg-[#E7E7E7] rounded-lg p-[1px]  w-fit mx-auto">
            <button
              onClick={() => setBillingCycle("yearly")}
              className={`rounded-md py-2.5 px-4 transition-colors ${
                billingCycle === "yearly"
                  ? "bg-primary_alt text-white"
                  : "bg-white text-black"
              }`}
            >
              Yearly
            </button>
            <button
              onClick={() => setBillingCycle("monthly")}
              className={`rounded-md py-2.5 px-4 transition-colors ${
                billingCycle === "monthly"
                  ? "bg-primary_alt text-white"
                  : "bg-white text-black"
              }`}
            >
              Monthly
            </button>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="bg-white">
          <div className="py-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-[24px]">
            {plans.map((p) => (
              <div
                key={p.title}
                className="flex flex-col gap-4 md:gap-8 px-4 py-8 rounded-xl border-[1.5px] border-[#E7E7E7] hover:border-[#1849D6]"
              >
                <div className="flex flex-col items-center justify-center gap-2">
                  <img src={p.image} alt="pricing" />
                  <h3 className="text-lg lg:text-[20px] font-medium text-black">
                    {p.title}
                  </h3>
                  <h4 className="text-[32px] lg:text-[48px] font-bold md:font-medium text-black">
                    {billingCycle === "yearly" ? p.price : p.price}
                  </h4>
                </div>

                <div className="space-y-3 md:space-y-[24px]">
                  {p.features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <CheckIcon />
                      <span className="text-[#222] text-sm">{feature}</span>
                    </div>
                  ))}
                </div>

                <Link
                  to={p.path}
                  className="rounded-lg bg-primary_alt border border-[#B6E4FF] py-2.5 px-4 text-white w-full text-center max-w-[300px] mx-auto"
                >
                  Get Started
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
